<template>
  <div class="modal-out">
    <div class="modal" style="width: 700px">
      <div class="modal-header">
        <div class="title">编辑时间</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <div style="height: 20px;"></div>
        <el-row>
          <el-col :span="12" class="item">
            <div>创建时间</div>
            <el-date-picker
                v-model="createTime"
                            type="datetime"
                            style="width:100%;"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择创建时间">
            </el-date-picker>
          </el-col>
          <el-col :span="12" class="item">
            <div>预约时间</div>
            <el-date-picker
                v-model="planTime"
                            type="datetime"
                            style="width:100%;"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择预约时间">
            </el-date-picker>
          </el-col>


        </el-row>
        <div style="height: 20px;"></div>
        <el-row>
          <el-col :span="12" class="item">
            <div>开始时间</div>
            <el-date-picker @change="startTimeChange"
                            v-model="startTime"
                            type="datetime"
                            style="width:100%;"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-col>
          <el-col :span="12" class="item">
            <div>结束时间</div>
            <el-date-picker @change="endTimeChange"
                            v-model="endTime"
                            type="datetime"
                            style="width:100%;"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-col>
        </el-row>
        <div style="height: 20px;"></div>
        <el-row>
          <el-col :span="12" class="item">
            <div>服务时长</div>
            <el-input v-model="spanTime" disabled style="width: 100%"></el-input>
          </el-col>
        </el-row>



      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm()">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'GetGood',
  data() {
    return {

      loading: false,

      orderBusinessCode:'',

      createTime:'',
      planTime:'',
      startTime:'',
      endTime:'',

      spanTime:0,


    }
  },
  components:{

  },
  methods: {
    init(row){

      this.orderBusinessCode = row.orderBusinessCode;
      this.startTime = timefilters(row.startTime);
      this.endTime = timefilters(row.completeTime);
      this.createTime = timefilters(row.createTime);
      this.planTime = timefilters(row.planTime);

      this.endTimeChange(this.endTime);

    },
    closeSelf() {
      this.$emit("closeEdit");
    },

    startTimeChange(val){
      if(val){
        var st = Date.parse(new Date(timefilters(val)));
        var et = Date.parse(new Date(timefilters(this.endTime)));

        if(et>=st){
          let ss = et-st;
          //console.log(ss/1000/60/60);
          let dd = ss/1000/60/60;
          this.spanTime = parseFloat(dd).toFixed(2);
        }

      }
    },
    endTimeChange(val){
      if(val){
        var et = Date.parse(new Date(timefilters(val)));
        var st = Date.parse(new Date(timefilters(this.startTime)));

        if(et>=st){
          let ss = et-st;
          //console.log(ss/1000/60/60);
          //this.spanTime = ss/1000/60/60;
          let dd = ss/1000/60/60;
          this.spanTime = parseFloat(dd).toFixed(2);
        }
      }
    },



    confirm(){

      if(this.createTime =='' || this.createTime == null){
        this.$message.info("请选择创建时间");
        return;
      }
      if(this.planTime =='' || this.planTime == null){
        this.$message.info("请选择预约时间");
        return;
      }
      if(this.startTime =='' || this.startTime == null){
        this.$message.info("请选择开始时间");
        return;
      }
      if(this.endTime =='' || this.endTime == null){
        this.$message.info("请选择结束时间");
        return;
      }

      var et = Date.parse(new Date(timefilters(this.endTime)));
      var st = Date.parse(new Date(timefilters(this.startTime)));
      if(st>=et){
        this.$message.info("结束时间应晚于开始时间");
        return;
      }


      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"OrderBusinessGov/EditServeTime",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          orderBusinessCode:this.orderBusinessCode,
          startTime:this.startTime,
          endTime:this.endTime,
          createTime:this.createTime,
          planTime:this.planTime,

        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.closeSelf();
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },






  }
}


</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>
